import { type ActionCreator, on, type ReducerTypes } from '@ngrx/store';
import { produce } from 'immer';

import { setTargetWorkflow } from './target-workflow.actions';
import { type TargetWorkflowEngineState } from './target-workflow.state';

export const targetWorkflowReducerTypes: readonly ReducerTypes<
  TargetWorkflowEngineState,
  ActionCreator[]
>[] = [
  on(setTargetWorkflow, (state, { workflow, action }) =>
    produce(state, (draft) => {
      draft.targetWorkflow = {
        workflow,
        action,
      };
    }),
  ),
];
